import React, { useState } from 'react';
import './PanelOverlay.scss';
import { PanelComponentKeyType } from 'config/panelConfig';
import { ICON_MAP } from '@components/Icons/Icons';
import { scheduleRender } from '../renderState';
import { usePanelContainer } from '../usePanelContainer';

interface PanelOverlayButtonProps {
  componentKey: PanelComponentKeyType;
  isOverlayButton:boolean;
}

const LABELS = ['RCA', 'LCA', 'Aorta'] as const;
type LabelType = typeof LABELS[number];

const PanelOverlayButton: React.FC<PanelOverlayButtonProps> = ({
  componentKey,
  isOverlayButton,
}) => {
  const [checkedMap, setCheckedMap] = useState<Record<LabelType, boolean>>({
    RCA: true,
    LCA: true,
    Aorta: true,
  });

  const CheckboxIcon = ICON_MAP.checkbox;

  const { panelStates } = usePanelContainer();
  const segmentation = panelStates['Surface3D']?.segmentation;

  /**
   * toggle handler
   */
  const handleToggle = (label: LabelType) => {
    setCheckedMap((prev) => {
      const nextChecked = !prev[label];

      if (label === 'Aorta') {
        const targetKey = 'aorta';
        if (segmentation?.aorta) {
          const current = segmentation[targetKey];
          const newSegmentation = {
            ...segmentation,
            [targetKey]: {
              ...current,
              opacity: 0.2,
              visibility: nextChecked,
            },
          };
          requestAnimationFrame(() => {
            scheduleRender('Surface3D', {
              type: 'updateSegmentation',
              name: targetKey,
              newSegmentation,
              visibleFFR:nextChecked,
            });
          });
        }
      } else {
        requestAnimationFrame(() => {
          scheduleRender('Surface3D', {
            type: 'updateSegmentation',
            visibleFFR: nextChecked,
            name: label.toLowerCase(),
          });
        });
      }

      return {
        ...prev,
        [label]: nextChecked,
      };
    });
  };

  /**
   * 클릭 핸들러 분리 (렌더 최적화)
   */
  const handleClick = (label: LabelType) => (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    handleToggle(label);
  };

  const handleDoubleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  if (componentKey !== 'Surface3D') return null;

  return isOverlayButton ? (
    <div className="tooltip-wrapper-FFR">
      {LABELS.map((label) => (
        <div className="checkbox" key={label}>
          <label className="container" onDoubleClick={handleDoubleClick}>
            <span
              className="checkbox-visual"
              aria-hidden="true"
              onClick={handleClick(label)}
            >
              {checkedMap[label] && CheckboxIcon && (
                <CheckboxIcon className="icon" />
              )}
            </span>
            <span className="checkbox-label">{label}</span>
          </label>
        </div>
      ))}
    </div>
  ) : null;
};

export default React.memo(PanelOverlayButton);
